const mixins = {
	data(){
		return{
			tableData:[],
			total:0,
			queryParams:{
				pageNo:1,
				pageSize:10
			}
		}
	},
	methods:{
		changePage(e){
			this.queryParams.pageNo = e
			this.getData()
		}
	},
	created(){
		this.getData()
	}
}

export default mixins